// frontend/src/components/feed/MustReadBanner.tsx
// App-wide, non-dismissible banner that follows the viewer everywhere while
// they have outstanding must-reads (requires_ack posts they haven't acked).
// Renders null when there are none (so unconditional mounting is safe) — this
// also keeps it silent on non-messaging tenants / guests, since useMustReads
// treats any error as an empty list. Mirrors PastDueBanner's null-return +
// styling. The CTA routes to /feed where the oldest outstanding post lives.
import { useNavigate } from 'react-router-dom'
import { useLanguage } from '../../i18n/index.jsx'
import { useMustReads } from '../../hooks/useMustReads.js'
import { Btn } from '../ui/Button.js'
import './feed.css'

export default function MustReadBanner() {
  const navigate = useNavigate()
  const { t } = useLanguage()
  const { count } = useMustReads()

  if (count === 0) return null

  return (
    <div
      role="alert"
      data-testid="must-read-banner"
      aria-label={t('feed.mustRead.title')}
      className="feed-mustread-banner"
    >
      <span className="feed-mustread-banner__text">
        {t('feed.mustRead.banner', { count })}
      </span>
      <Btn type="button" size="sm" variant="ghost" className="feed-mustread-banner__cta" onClick={() => navigate('/feed')}>
        {t('feed.mustRead.cta')}
      </Btn>
    </div>
  )
}
